var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import styled, { css } from 'styled-components';
import Button from '../../base/Button';
import Card, { CardBody } from '../../base/Card';
import Icon from '../../base/Icon';
import ListView, { ListViewHeader } from '../../base/ListView';
import Loader from '../../base/Loader';
import Popup from '../../base/Popup';
import Typography from '../../base/Typography';
var StyledButton = styled(Button)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", "\n"])), props => css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        border-width: 0;\n        padding: 0.25rem;\n\n        &:hover {\n            color: ", "\n        }\n\n        &.k-focus::before,\n        &:focus::before,\n        &:hover::before {\n            opacity: 0;\n        }\n    "])), props.theme.component.secondaryHover));
var StyledCard = styled(Card)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    ", "\n"])), props => css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n        .k-card-body {\n            padding: 0 1rem;\n\n            .k-listview {\n                border-width: 0;\n\n                .k-listview-content {\n                    .list-item {\n                        padding: 0.5rem 0;\n\n                        & > .k-button > .k-button-text > svg {\n                            color: ", ";\n                        }\n                    }\n                }\n            }\n        }\n    "])), props.theme.typography.textColor));
var AppPicker = props => {
  var {
    applications,
    noneMessage,
    show,
    title
  } = props;
  var anchor = useRef(null);
  var popup = useRef(null);
  var [internalApplications, setInternalApplications] = useState(null);
  var [internalShow, setInternalShow] = useState(false);
  var itemRender = useCallback(item => {
    var {
      dataItem
    } = item;
    if (!applications || (applications === null || applications === void 0 ? void 0 : applications.length) === 0) return dataItem;
    if (dataItem) {
      return /*#__PURE__*/React.createElement("div", {
        className: "list-item"
      }, /*#__PURE__*/React.createElement(Button, {
        onClick: dataItem.onClick ? () => {
          dataItem.onClick();
          setInternalShow(false);
        } : () => {
          window.open(dataItem.url, '_blank');
        },
        variant: "link"
      }, dataItem.icon && /*#__PURE__*/React.createElement(Icon, {
        icon: dataItem.icon,
        style: {
          height: '1.75rem',
          width: '1.75rem'
        }
      }), /*#__PURE__*/React.createElement("span", {
        style: {
          marginLeft: "".concat(dataItem.icon ? '0.5rem' : '2.25rem')
        }
      }, dataItem.name)));
    }
    return null;
  }, [applications]);
  useEffect(() => {
    if (applications) {
      if ((applications === null || applications === void 0 ? void 0 : applications.length) === 0) {
        setInternalApplications([/*#__PURE__*/React.createElement(Typography, null, noneMessage)]);
      } else {
        setInternalApplications(applications);
      }
    } else {
      setInternalApplications([/*#__PURE__*/React.createElement(Loader, {
        style: {
          justifyContent: 'center'
        },
        type: "pulsing"
      })]);
    }
  }, [applications, noneMessage]);
  var handleClick = useCallback(event => {
    if (anchor.current.contains(event.target) || popup.current.contains(event.target)) {
      return;
    }
    setInternalShow(false);
  }, []);
  useEffect(() => {
    if (internalShow) {
      document.addEventListener('mousedown', handleClick);
    } else {
      document.removeEventListener('mousedown', handleClick);
    }
    return () => {
      document.removeEventListener('mousedown', handleClick);
    };
  }, [handleClick, internalShow]);
  useEffect(() => setInternalShow(show), [show]);
  var listViewHeader = useCallback(() => /*#__PURE__*/React.createElement(ListViewHeader, null, /*#__PURE__*/React.createElement(Typography, {
    size: "0.875rem",
    type: "title"
  }, title)), [title]);
  return /*#__PURE__*/React.createElement("div", {
    ref: anchor,
    style: {
      display: 'inline-flex'
    }
  }, /*#__PURE__*/React.createElement(StyledButton, {
    fillMode: "flat",
    onClick: () => setInternalShow(!internalShow),
    themeColor: "secondary"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: ['fas', 'grid'],
    style: {
      height: '1.5rem',
      width: '1.5rem'
    }
  })), /*#__PURE__*/React.createElement(Popup, {
    anchor: anchor.current,
    anchorAlign: {
      horizontal: 'right',
      vertical: 'bottom'
    },
    borderless: true,
    onClose: () => {
      setInternalShow(false);
    },
    popupAlign: {
      horizontal: 'right',
      vertical: 'top'
    },
    show: internalShow
  }, /*#__PURE__*/React.createElement("div", {
    ref: popup
  }, /*#__PURE__*/React.createElement(StyledCard, null, /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement(ListView, {
    data: internalApplications,
    header: listViewHeader,
    item: itemRender
  }))))));
};
AppPicker.defaultProps = {
  applications: undefined,
  noneMessage: 'No Applications Available',
  show: undefined,
  title: 'Applications'
};
AppPicker.propTypes = {
  /**
   * Array of application config settings to display in the listview
   */
  applications: PropTypes.arrayOf(PropTypes.shape({
    icon: PropTypes.arrayOf(PropTypes.string),
    name: PropTypes.string,
    onClick: PropTypes.func,
    url: PropTypes.string
  })),
  /**
   * Message to display when there are no applications in the list
   */
  noneMessage: PropTypes.string,
  /**
   *  Controls the Popup visibility.
   */
  show: PropTypes.bool,
  /**
   * Title to display as the listview header
   */
  title: PropTypes.string
};
export default AppPicker;